export enum FilterReportsFieldNames {
  Id = 'id',
  UserId = 'user_id',
  GroupId = 'group_id',
  Trigger = 'trigger',
  Status = 'status',
  FirstName = 'first_name',
  LastName = 'last_name',
  CreationTimestamp = 'creation_timestamp',
}

export enum FilterGroupsFieldNames {
  Name = 'name',
}

export enum Timeframes {
  Custom = 'custom',
  lastWeek = 'last_week',
  lastMonth = 'last_month',
  lastThreeMonths = 'last_three_months',
  lastYear = 'last_year',
}

export enum FilterDateChoices {
  lastWeek = 'last_week',
  lastMonth = 'last_month',
  lastThreeMonths = 'last_three_months',
  lastYear = 'last_year',
  beforeDate = 'before_date',
  afterDate = 'after_date',
  betweenDates = 'between_dates',
}

export interface FilterBadge {
  queryParameter: string;
  label: string;
  renderValue: (value: string) => string;
}
